/* eslint-disable */
import React from 'react'
import http from '../Interceptor/Interseptor'
import jMoment from 'moment-jalaali'
import {Checkbox, message} from 'antd'
import Select from 'react-select'
import {Link} from 'react-router-dom'
import cookie from 'react-cookies'
import $ from 'jquery'
import REPORT_RETAIL from '../BaseComponent/REPORTRETAIL'
import WAREHOUSE from '../BaseComponent/WAREHOUSE'
import {Modal, ModalBody, ModalFooter, ModalHeader} from 'mdbreact'
import FromToPicker from '../BaseComponent/FromToPicker'
import HeaderTablePrint from '../BaseComponent/HeaderTablePrint'
import ExcelExport from '@progress/kendo-react-excel-export/dist/npm/ExcelExport'
import HeaderGrid from '../Pagination/HeaderGrid'
import Sort from '../Pagination/Sort'
import Pageing from '../Pagination/pageing'
import Loader from '../loaders/loader'
import USER_MANAGE from '../BaseComponent/USERMANAGE'
import SearchableCombo from '../BaseComponent/searchableCombo'
import SearchCustomer from '../BaseComponent/SearchCustomer'
import {accounting} from 'accounting'
import {orderInfo, productShop, editOrder} from '../../lib/path'
import AutoComplete from '../BaseComponent/autocomplete'

class UsersEditedInvoice extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      checkAll: false,
      loading: false,
      wareHousesname: [],
      docType: [],
      errorForm: '',
      showTable: false,
      listWareHouse: [],
      preRecordInfo: {},
      urlQuery: '',
      providers: [],
      providerValue: '',
      selectedOption: [],
      wareType: [],
      report: [],
      fromDate: '',
      toDate: '',
      modalDelete: false,
      fromManual: '',
      toManual: '',
      printInfo: [],
      printFrom: '',
      printTo: '',
      buttonClicked: false,
      customerCode: '',
      pageNumber: 1,
      pageSize: 10,
      countAll: 0,
      sortBy: '',
      getSort: '',
      details: [],
      sortData: [
        {
          name: 'انتخاب',
          value: 'id',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'ردیف',
          value: 'id',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'نام',
          value: 'id',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'شماره فاکتور',
          value: 'id',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'کدمشتری',
          value: 'id',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'موبایل',
          value: 'id',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'جزییات فاکتور',
          value: 'id',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'وضعیت اطلاع رسانی',
          value: 'id',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'پردازش',
          value: 'id',
          sorted: false,
          direction: null,
          sortable: false
        }
      ],
      operators: [],
      roleBackOperators: [],
      operatorId: '',
      rollBackOperatorId: ''
    }
  }

  getValueProvider = (providerId) => {
    if (providerId === null) {
      this.setState({
        providerId: []
      })
    } else {
      this.setState({
        providerId
      })
    }
  }

  submitForm(e) {
    e.preventDefault()
  }

  componentDidMount() {
    $(function() {
      $('.filterBtn').on('click', function() {
        $('.basketFilterComponent').slideToggle()
      })
    })

    sessionStorage.setItem('pageNumber', '1')
    sessionStorage.setItem('dropDownVal', '10')
  }

  getReport = (exportStatus) => {
    this.setState({
      loading: true
    })
    let filter = this.createFilter(exportStatus)
    http
      .get(`invoices/edition/get/users`, {
        params: filter
      })
      .then((response) => {
        if (response.data.error === null) {
          let res = response.data.object
          for (let i in res) {
            res[i].checked = false
          }
          $('.showBaseTable,.print').fadeIn()
          this.setState({
            report: response.data.object,
            printFrom: this.state.fromDate == '' ? ' - ' : jMoment(this.state.fromDate).format('jYY/jMM/jDD'),
            printTo: this.state.toDate == '' ? ' - ' : jMoment(this.state.toDate).format('jYY/jMM/jDD'),
            buttonClicked: true,
            loading: false,
            lengthList: response.data.object.countAll
          })
        } else {
          $('.showBaseTable,.print').fadeOut()
          this.setState({
            listWareHouse: [],
            lengthList: 0,
            loading: false
          })
          // message.error('خطای ' + response.data.errorCode + ' : ' + response.data.description)
        }
      })
      .catch((error) => {
        alert(JSON.stringify(error))
        this.setState({
          loading: false
        })
      })
  }

  handleChangeFromDate = (fromDate) => {
    this.setState({
      fromDate
    })
  }

  handleChangeToDate = (toDate) => {
    this.setState({
      toDate
    })
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevState.pageNumber !== this.state.pageNumber) {
      this.getReport(false)
    }
    if (prevState.pageSize !== this.state.pageSize) {
      this.getReport(false)
    }
    if (prevState.sortBy !== this.state.sortBy) {
      this.getReport(false)
    }
  }

  getPageNumber = (pageNumber) => {
    this.setState({
      pageNumber
    })
  }

  getPageSize = (pageSize) => {
    this.setState({
      pageSize,
      pageNumber: 1
    })
  }
  getSort = (sortBy) => {
    this.setState({
      sortBy
    })
  }

  createFilter = (exportStatus) => {
    let filter = {}
    let providerId = this.state.providerId
    let fromTime = this.state.fromDate
    let toTime = this.state.toDate
    let userCode = this.state.customerCode
    if (this.state.sortBy !== '') {
      filter.sortBy = this.state.sortBy
    }
    if (fromTime !== '') {
      filter.fromTime = fromTime
    }
    if (userCode !== '') {
      filter.userCode = userCode
    }

    if (this.state.operatorId !== '') {
      filter.operatorId = this.state.operatorId.personId
    }
    if (this.state.rollBackOperatorId !== '') {
      filter.rollBackOperatorId = this.state.rollBackOperatorId.personId
    }

    if (toTime !== '') {
      filter.toTime = toTime
    }

    if (providerId !== '') {
      filter.providerId = providerId
    }

    return filter
  }

  filter() {
    let {fromDate, toDate} = this.state
    if (fromDate === '' || toDate === '') {
      message.error('هر دو تاریخ وارد شود')
    } else {
      this.getReport(false)
    }
  }

  getPrintInfo = () => {
    this.setState({
      loading: true
    })
    let filter = this.createFilter(true)

    http
      .get(`invoices/edition/get/users`, {
        params: filter
      })
      .then((response) => {
        if (response.data.error == null) {
          $('.showBaseTable,.print').fadeIn()

          this.setState({
            printInfo: response.data.object.result,
            lengthList: response.data.object.countAll,
            loading: false
          })
        } else {
          this.setState({
            printInfo: [],
            loading: false
          })
        }
      })
      .catch((error) => {
        this.setState({
          loading: false
        })
      })
  }

  exportPrint = () => {
    var css = '@page { size:A4 portrait;}',
      head = document.head || document.getElementsByTagName('head')[0],
      style = document.createElement('style')

    style.type = 'text/css'
    style.media = 'print'

    if (style.styleSheet) {
      style.styleSheet.cssText = css
    } else {
      style.appendChild(document.createTextNode(css))
    }

    head.appendChild(style)
    this.getPrintInfo()
    setTimeout(() => {
      window.print()
    }, 2000)
  }

  exportExcel = () => {
    let filter = this.createFilter(true)

    http
      .get(`invoices/edition/get/users`, {
        params: filter
      })
      .then((response) => {
        if (response.data.error == null) {
          this.setState({
            excelReport: response.data.object.result
          })
          let excelReport = this.state.excelReport
          for (let i = 0; i < excelReport.length; i++) {
            excelReport[i].created = jMoment(excelReport[i].created)
            if (excelReport[i].rolledBackTime !== null) {
              excelReport[i].rolledBackTime = jMoment(excelReport[i].rolledBackTime)
            }
            if (excelReport[i].rollBacked) {
              excelReport[i].rollBacked = 'بازگشت شده'
            } else {
              excelReport[i].rollBacked = 'بازگشت نشده'
            }
          }

          this._export.save(excelReport)
        }
      })
  }

  getSingleCustomerCode = (customerCode) => {
    this.setState({
      customerCode
    })
  }

  showInvoice = (details, informed, firstName, lastName) => {
    this.setState({
      details,
      informed,
      fullName: firstName + ' ' + lastName,
      detailsModal: true
    })
  }

  sendInform() {
    let details = this.state.details
    let sendSms = document.getElementById('sendSms').value
    let ids = []
    for (let i in details) {
      ids.push(details[i].id)
    }

    let data = {
      ids,
      sendSms
    }
    http.patch(`invoices/edition/inform`, data, {}).then((res) => {
      if (res.data.error === null) {
        message.success('اطلاع رسانی با موفقیت انجام شد')
        this.setState({
          detailsModal: false
        })
        this.getReport()
      } else {
        message.error(res.data.description)
      }
    })
  }

  sendInformation = (number, details, firstName, lastName) => {
    this.setState({
      details,
      number,
      fullName: firstName + ' ' + lastName,
      modalInformation: true
    })
  }

  sendOk = () => {
    let {details, number, fullName} = this.state
    let sendSms = document.getElementById('sendSms' + number).value

    let ids = []
    for (let i in details) {
      ids.push(details[i].id)
    }
    let data = {
      ids,
      sendSms
    }
    http.patch(`invoices/edition/inform`, data, {}).then((res) => {
      if (res.data.error === null) {
        message.success('اطلاع رسانی با موفقیت انجام شد')
        this.setState({
          modalInformation: false
        })
        this.getReport()
      } else {
        message.error(res.data.description)
      }
    })
  }

  setProcess = (number, details, firstName, lastName) => {
    this.setState({
      details,
      number,
      fullName: firstName + ' ' + lastName,
      modalProcess: true
    })
  }
  proccessOk = () => {
    let {details} = this.state
    let ids = []
    for (let i in details) {
      ids.push(details[i].id)
    }
    let data = {
      ids
    }

    http.patch(`invoices/edition/process`, data, {}).then((res) => {
      if (res.data.error === null) {
        message.success('پردازش با موفقیت انجام شد')
        this.setState({
          modalProcess: false
        })
        this.getReport()
      } else {
        message.error(res.data.description)
      }
    })
  }

  sendMultiInformModal = () => {
    let report = this.state.report
    let findCheck = report.filter((item) => item.checked === true)
    let smsMulti = document.getElementById('smsMulti').value
    if (findCheck.length === 0) {
      message.error('حداقل یک نفر برای انجام اطلاع رسانی انتخاب شود')
    } else {
      this.setState({
        multiInformModal: true
      })
    }
  }

  sendMultInform = () => {
    let report = this.state.report
    let findCheck = report.filter((item) => item.checked === true)
    let smsMulti = document.getElementById('smsMulti').value
    if (findCheck.length === 0) {
      message.error('حداقل یک نفر برای انجام اطلاع رسانی انتخاب شود')
    } else {
      if (window.confirm('آیا از اطلاع رسانی به افراد انتخاب شده مطمئن هستید؟')) {
        let ids = []
        for (let i in findCheck) {
          for (let j in findCheck[i].details) {
            ids.push(findCheck[i].details[j].id)
          }
        }
        let data = {
          ids,
          sendSms: smsMulti
        }
        http.patch(`invoices/edition/inform`, data, {}).then((res) => {
          if (res.data.error === null) {
            message.success('اطلاع رسانی با موفقیت انجام شد')
            this.setState({
              multiInformModal: false
            })
            this.getReport()
          } else {
            message.error(res.data.description)
          }
        })
      }
    }
  }

  toggleUser = (num, checked) => {
    let report = this.state.report
    report[num].checked = !checked
    this.setState({
      report
    })
  }

  showInvoiceIds = (details) => {
    if (details.length !== 0) {
      let arr = []
      details.forEach((item) => {
        arr.push(item.invoiceNum)
      })
      return arr
    } else {
      return []
    }
  }

  renderDetails = () => {
    let {checkAll} = this.state
    if (!checkAll) {
      return this.state.details.filter((i) => !i.rolledBack)
    } else {
      return this.state.details
    }
  }

  render() {
    const {loading} = this.state
    let {pageNumber, pageSize} = this.state

    return (
      <div className="rtl">
        <Loader show={loading} />

        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>توزیع</li>
            <li>ویرایش فاکتورها</li>
            <li>مشتریانی که فاکتورهایشان ویرایش شده</li>
          </ul>
          <div className="tableComponent">
            <div className="basketFilterComponent">
              <div className="filterInputs">
                <SearchCustomer
                  label={'کد مشتری'}
                  getSingleCustomerCode={this.getSingleCustomerCode}
                  singleResult={true}
                  searchLabel={'جست و جوی مشتری'}
                />

                <FromToPicker
                  onChangeFromDate={this.handleChangeFromDate}
                  onChangeToDate={this.handleChangeToDate}
                  fromLabel="تاریخ از"
                  toLabel="تاریخ تا"
                  fromId="from"
                  toId="to"
                  defaulValue
                  force
                />

                <div className="formComponent selectComponent">
                  <AutoComplete
                    label="تامین کننده"
                    api={`${REPORT_RETAIL.REPORT_RETAIL_LIST_PROVIDER}`}
                    textField="title"
                    valueField="providerId"
                    id="provider"
                    value={this.state.providerId}
                    setValue={(providerId) => this.setState({providerId})}
                  />
                  {/* 
                                    <label className={'font-weight-bold'}>تامین کننده </label>
                                    <Select
                                        options={this.state.providers}
                                        isClearable={true}
                                        placeholder={'------'}
                                        value={this.state.providerId}
                                        onChange={this.getValueProvider}
                                    /> */}
                </div>
              </div>
              <div className="filterOption">
                <button className="confirmFilter" onClick={this.filter.bind(this)}>
                  جست و جو
                </button>
              </div>

              {this.state.report.length !== 0 && (
                <div className="container-fluid">
                  <hr />
                  <div className="row">
                    <div className="col-2 p-2">
                      <div>
                        <label>اطلاع رسانی</label>
                        <select className="form-control" id="smsMulti">
                          <option value={false}>دستی</option>
                          <option value={true}>به همراه sms</option>
                        </select>
                      </div>
                    </div>
                    <div className="col-2 p-2">
                      <div>
                        <label className="invisible">اطلاع رسانی</label>
                        <span
                          onClick={() => this.sendMultiInformModal()}
                          style={{
                            background: '#f7a732',
                            border: '1px solid #f7a732'
                          }}
                          className="searchCustommer"
                        >
                          اطلاع رسانی چندتایی
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>

            <div className="showBaseTable print">
              <table className="baseTable">
                <tbody>
                  <Sort data={this.state.sortData} getSort={this.getSort} />

                  {this.state.report.map((item, index) => (
                    <tr key={index}>
                      <td style={{width: '70px'}}>
                        {/*{!item.informed &&*/}
                        {/*<span onClick={()=>this.toggleUser(index,item.checked)}>*/}
                        {/*    {item.checked && <img src={require('../../image/checkbox.svg')}/>}*/}
                        {/*    {!item.checked && <img src={require('../../image/unCheckBox.svg')}/>}*/}
                        {/*</span>*/}
                        {/*}*/}
                      </td>
                      <td>{(pageNumber - 1) * pageSize + index + 1}</td>
                      <td>{item.firstName + ' ' + item.lastName}</td>
                      <td>
                        {item.details.map(
                          (i, numb) =>
                            numb === 0 && (
                              <a target="_blank" href={editOrder({invoiceId: i.invoiceId})}>
                                {numb !== 0 ? ' , ' : ''}
                                {i.invoiceNum}
                              </a>
                            )
                        )}
                      </td>
                      <td>
                        <Link target="_blank" to={`/base/users/persina/${item.userCode}`}>
                          {item.userCode}
                        </Link>
                      </td>
                      <td>{item.mobile !== null && item.mobile.replace(/\+98/g, '0')}</td>
                      <td>
                        {item.details !== null && (
                          <img
                            style={{cursor: 'pointer'}}
                            src={require('../../image/details.svg')}
                            onClick={() => this.showInvoice(item.details, item.informed, item.firstName, item.lastName)}
                          />
                        )}
                      </td>
                      <td style={{width: '200px'}}>
                        {item.informed ? (
                          <img src={require('../../image/confirm.svg')} width="30px" />
                        ) : (
                          <div className="d-flex flex-row justify-content-around text-left">
                            <figure className="">
                              <label>اطلاع رسانی : </label>
                              <select style={{width: '90px'}} id={`sendSms${index}`} className="form-control">
                                <option value={false}>دستی</option>
                                <option value={true}>به همراه sms</option>
                              </select>
                            </figure>
                            <figure>
                              <label className="hiddenLabel">332</label>
                              <span
                                onClick={() => this.sendInformation(index, item.details, item.firstName, item.lastName)}
                                className="searchCustommer"
                                style={{
                                  background: '#f7a732',
                                  border: '1px solid #f7a732',
                                  width: '90px'
                                }}
                              >
                                اطلاع رسانی
                              </span>
                            </figure>
                          </div>
                        )}
                      </td>
                      <td style={{width: '90px'}}>
                        {!item.processed ? (
                          <figure>
                            <label className="hiddenLabel">332</label>
                            <span
                              onClick={() => this.setProcess(index, item.details, item.firstName, item.lastName)}
                              className="searchCustommer"
                            >
                              ثبت پردازش
                            </span>
                          </figure>
                        ) : (
                          <img src={require('../../image/confirm.svg')} width="30px" />
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <Modal
          isOpen={this.state.detailsModal}
          toggle={() => this.setState({detailsModal: false, checkAll: false})}
          size="lg"
        >
          <ModalHeader toggle={() => this.setState({detailsModal: false, checkAll: false})}>
            لیست فاکتور های {this.state.fullName}
          </ModalHeader>
          <ModalBody>
            {this.state.checkAll}
            <Checkbox
              name="isInternal"
              className="mt-0"
              tabIndex="4"
              checked={this.state.checkAll}
              onChange={() => this.setState({checkAll: !this.state.checkAll})}
            >
              <span className="text-dark">نمایش همه موارد</span>
            </Checkbox>
            <div className="unMatchClass overflow-auto">
              <table className="baseTable table-responsive">
                <tbody>
                  <tr className="firstRow">
                    <td>ردیف</td>
                    <td>شماره فاکتور</td>
                    <td>شناسه فاکتور</td>
                    <td style={{minWidth: '200px'}}>نام کالا در فاکتور</td>
                    <td>قیمت واحد</td>
                    <td>اعتبار هدیه</td>
                    <td>تعداد قبل از ویرایش</td>
                    <td>تعداد بعد از ویرایش</td>
                    <td>وضعیت ویرایش</td>
                    <td>وضعیت بازگشت</td>
                    <td>کاربر اطلاع رساننده</td>
                    <td>تاریخ اطلاع رسانی</td>
                    <td>کاربر پردازش کننده</td>
                    <td>تاریخ پردازش</td>
                    <td>کاربر ویرایش کننده</td>
                    <td>تاریخ ویرایش</td>
                  </tr>
                  {this.renderDetails().length !== 0 ? (
                    this.renderDetails().map((item, index) => (
                      <tr key={index}>
                        <td style={{fontSize: '1.2em'}} className="font-weight-bolder">
                          {index + 1}
                        </td>
                        <td style={{fontSize: '1.2em'}} className="font-weight-bolder">
                          <a target="_blank" href={orderInfo({orderId: item.invoiceId})}>
                            {item.invoiceNum}
                          </a>
                        </td>
                        <td style={{fontSize: '1.2em'}} className="font-weight-bolder">
                          {item.invoiceId}
                        </td>
                        <td style={{fontSize: '1.2em'}} className="font-weight-bolder">
                          <a target="_blank" href={productShop({articleId: item.articleId})}>
                            {item.itemName}
                          </a>
                        </td>
                        <td style={{fontSize: '1.2em'}} className="font-weight-bolder">
                          {accounting.formatMoney(+item.payableAmount / +item.quantityBeforeEdition, '', ',')}
                        </td>
                        <td style={{fontSize: '1.2em'}} className="font-weight-bolder">
                          {accounting.formatMoney(
                            (+item.payableAmount / +item.quantityBeforeEdition) *
                              (+item.quantityBeforeEdition - item.quantityAfterEdition),
                            '',
                            ','
                          )}
                        </td>
                        <td style={{fontSize: '1.2em'}} className="font-weight-bolder">
                          {item.quantityBeforeEdition}
                        </td>
                        <td style={{fontSize: '1.2em'}} className="font-weight-bolder">
                          {item.quantityAfterEdition}
                        </td>
                        <td>
                          {item.edited ? (
                            <img src={require('../../image/confirm.svg')} width="30px" />
                          ) : (
                            <img src={require('../../image/ignor.svg')} width="30px" />
                          )}
                        </td>
                        <td>
                          {item.rolledBack ? (
                            <img src={require('../../image/confirm.svg')} width="30px" />
                          ) : (
                            <img src={require('../../image/ignor.svg')} width="30px" />
                          )}
                        </td>
                        <td>
                          {(item.informerFirstName !== null ? item.informerFirstName : '') +
                            ' ' +
                            (item.informerLastName !== null ? item.informerLastName : '')}
                        </td>
                        <td>
                          {item.informTime !== null ? jMoment(item.informTime).format('jYYYY/jMM/jDD HH:mm') : '-'}
                        </td>
                        <td>
                          {(item.processorFirstName !== null ? item.processorFirstName : '') +
                            ' ' +
                            (item.processorLastName !== null ? item.processorLastName : '')}
                        </td>
                        <td>
                          {item.processTime !== null ? jMoment(item.processTime).format('jYYYY/jMM/jDD HH:mm') : '-'}
                        </td>
                        <td>
                          {(item.editorFirstName !== null ? item.editorFirstName : '') +
                            ' ' +
                            (item.editorLastName !== null ? item.editorLastName : '')}
                        </td>
                        <td>
                          {item.editionTime !== null ? jMoment(item.editionTime).format('jYYYY/jMM/jDD HH:mm') : '-'}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={16}>
                        <h6 className="mb-0 font-weight-bold text-danger">موردی یافت نشد</h6>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </ModalBody>
          <ModalFooter>
            <button className="cancelBtnModal" onClick={() => this.setState({detailsModal: false, checkAll: false})}>
              بستن
            </button>
          </ModalFooter>
        </Modal>
        <Modal isOpen={this.state.modalInformation} toggle={() => this.setState({modalInformation: false})} size="md">
          <ModalHeader toggle={() => this.setState({modalInformation: false})}>
            اطلاع رسانی {this.state.fullName}
          </ModalHeader>
          <ModalBody>
            <p className="text-center font-weight-bold"> آیا از اطلاع رسانی به {this.state.fullName} مطمئن هستید؟؟ </p>
          </ModalBody>
          <ModalFooter>
            <button className="confirmBtnModal" onClick={this.sendOk}>
              ارسال
            </button>
            <button className="cancelBtnModal" onClick={() => this.setState({modalInformation: false})}>
              لغو
            </button>
          </ModalFooter>
        </Modal>

        <Modal isOpen={this.state.modalProcess} toggle={() => this.setState({modalProcess: false})} size="md">
          <ModalHeader toggle={() => this.setState({modalProcess: false})}>
            پردازش فاکتورهای {this.state.fullName}
          </ModalHeader>
          <ModalBody>
            <p className="text-center font-weight-bold">
              {' '}
              آیا از پردازش فاکتورهای {this.state.fullName} مطمئن هستید؟؟{' '}
            </p>
          </ModalBody>
          <ModalFooter>
            <button className="confirmBtnModal" onClick={this.proccessOk}>
              ارسال
            </button>
            <button className="cancelBtnModal" onClick={() => this.setState({modalProcess: false})}>
              لغو
            </button>
          </ModalFooter>
        </Modal>

        <Modal isOpen={this.state.multiInformModal} toggle={() => this.setState({multiInformModal: false})} size="md">
          <ModalBody>
            <p className="text-center font-weight-bold">آیا از اطلاع رسانی به افراد انتخاب شده مطمئن هستید؟؟</p>
          </ModalBody>
          <ModalFooter>
            <button className="confirmBtnModal" onClick={this.sendMultInform}>
              اطلاع رسانی
            </button>
            <button className="cancelBtnModal" onClick={() => this.setState({multiInformModal: false})}>
              لغو
            </button>
          </ModalFooter>
        </Modal>
      </div>
    )
  }
}

export default UsersEditedInvoice
